import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import { Link } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getError } from '../utility';
import { getCities, deleteCities, deleteCity } from '../apis/cities';
import { message, Table } from 'antd';
import { MdOutlineAdd } from 'react-icons/md';

const LocalLevels = () => {
    const [localLevels, setLocalLevels] = useState();
    const [pagination, setPagination] = useState({
      page: 1,
      pageSize: 8,
    })
    const queryClient = useQueryClient();
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        sorter: (a, b) => a.id - b.id,
      },
      {
        title: 'Name',
        dataIndex: 'name',
        render: (name, localLevel) => <Link to={`/local-levels/${localLevel.slug}`}>{name}</Link>
      },
      {
        title: 'Slug',
        dataIndex: 'slug',
      },
      {
        title: 'District',
        dataIndex: 'district',
        render: (district) => district.name,
      },
      {
        title: 'Actions',
        dataIndex: 'slug',
        render: (slug) => <button type='button' className='button button-danger' onClick={() => confirmAndDelete(slug)}>Delete</button>
      }
    ];

    const confirmAndDelete = (slug) => {
      if (window.confirm(`Are you sure to delete the local level with slug "${slug}"?\nNote that all the places associated with it will also be deleted!`)) deleteMutate({slug});
    }

    const { mutate: deleteMutate, isLoading: isDeleting } = useMutation(({slug}) => deleteCity({slug}), {
      onSuccess: (data) => {
          message.success("Local Level deleted successfully!");
          queryClient.invalidateQueries("get-local-levels");
      },
      onError: (error) => message.error(getError(error))
  })

    const { isLoading, refetch, isFetching } = useQuery(
      "get-local-levels",
      () => getCities(pagination),
      {
        onSuccess: (data) => {
          setLocalLevels(data.data);
        },
        onError: (error) => message.error(getError(error)),
        refetchInterval: 5 * 1000 * 60,
      }
    )
  
    useEffect(() => {
      refetch();
    }, [pagination.page, pagination.pageSize]);
  return (
    <main className="main model-view room">
      <Header title="Local Levels" />
      <div className='main-container'>
        <div className='actions-container'>
          <Link to="/local-levels/add/" className='button button-regular'><MdOutlineAdd /> Add Local Level</Link>
        </div>
        <div className='table-container'>
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={localLevels?.results}
            loading={isLoading || isFetching}
            pagination={{
              total: localLevels?.count,
              current: pagination.page,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} local-levels`,
              onChange: (page, pageSize) => setPagination({ page, pageSize }),
            }}
          />
        </div>
      </div>
    </main>
  )
}

export default LocalLevels